import { PlusOutlined, UnorderedListOutlined } from '@ant-design/icons'
import { PageHeader } from '@ant-design/pro-layout'
import { useCanForFeatures } from '@salescore/client-common'
import { CreateSourceConfirmModal, CreateSourceForm } from '@salescore/client-feature-setting'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { App, Button } from 'antd'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'

import { SourcesTable } from '../../../../../../components/SourcesTable.tsx'

const Page = (): ReactElement => {
  const { modal } = App.useApp()
  const { t } = useTranslation()
  const { organizationId } = Route.useParams()
  const { oauthCode, state, provider } = Route.useSearch()
  const navigate = useNavigate()
  const { canManageEltModel } = useCanForFeatures()
  return (
    <PageHeader
      title={t(`連携先一覧`)}
      extra={[
        ...(canManageEltModel
          ? [
              <Button
                key="list"
                icon={<UnorderedListOutlined />}
                onClick={() => {
                  void navigate({ to: '/o/$organizationId/v2/settings/elt_models', params: { organizationId } })
                }}
              >
                {t(`オブジェクト一覧`)}
              </Button>,
            ]
          : []),
        <Button
          key="create"
          icon={<PlusOutlined />}
          type="primary"
          onClick={() => {
            const m = modal.info({
              title: t(`連携を編集`),
              width: 'min(80%, 1600px)',
              okText: t(`閉じる`),
              okType: 'default',
              content: (
                <CreateSourceForm
                  onFinish={() => {
                    m.destroy()
                  }}
                  redirectToConnection={(sourceId: string) => {
                    void navigate({
                      to: '/o/$organizationId/v2/settings/sources/$sourceId/connection',
                      params: { organizationId, sourceId },
                    })
                  }}
                />
              ),
            })
          }}
        >
          {t(`作成`)}
        </Button>,
      ]}
    >
      <SourcesTable organizationId={organizationId} />
      <CreateSourceConfirmModal
        oauthCode={oauthCode}
        provider={provider}
        state={state}
        redirectToConnection={(sourceId) => {
          void navigate({
            to: '/o/$organizationId/v2/settings/sources/$sourceId/connection',
            params: { organizationId, sourceId },
          })
        }}
      />
    </PageHeader>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/sources/')({
  component: Page,
  validateSearch: (search) =>
    z
      .object({ oauthCode: z.string().optional(), state: z.string().optional(), provider: z.string().optional() })
      .parse(search),
})
